<!-- eslint-disable vue/no-v-html -->
<template>
  <MLayoutStack @focusin="handleOnFocus">
    <component
      :is="element.componentName"
      v-bind="element.props"
      :model-value="element.modelValueKey ? formValues[element.modelValueKey] : null"
      @update:model-value="handleValueUpdate"
      @blur="handleOnBlur"
    >
      <template v-if="props.element.children">
        <MConsultationTemplateFormElement
          v-for="(item, index) in props.element.children"
          :key="'element' + index"
          :element="item"
          :form-values="formValues"
          @form-value-update="handleFormValueUpdate"
          @field-focused="(p) => emit('fieldFocused', p)"
          @field-blurred="(p) => emit('fieldBlurred', p)"
        />
      </template>
      <template v-if="element.content">
        {{ element.content }}
      </template>
      <span
        v-if="element.markdown"
        v-html="marked.parse(element.markdown, { breaks: true, gfm: true, renderer })"
      ></span>
    </component>
  </MLayoutStack>
</template>

<script setup lang="ts">
import MConsultationTemplateFormElement from "./MConsultationTemplateFormElement.vue";
import MLayoutStack from "../../MLayoutStack/MLayoutStack.vue";
import { marked } from "marked";
import { defineEmits } from "vue";
const props = defineProps({
  element: Object,
  formValues: Object,
});

const emit = defineEmits<{
  (e: "formValueUpdate", payload?: { modelValueKey: string; value: unknown; label?: string }): void;
  (e: "fieldFocused", payload: { modelValueKey: string; value: unknown; label?: string }): void;
  (e: "fieldBlurred", payload: { modelValueKey: string; value: unknown; label?: string }): void;
}>();

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const html = linkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a /, '<a target="_blank" ');
};

function payload() {
  const key = props.element?.modelValueKey;
  if (!key) return undefined;
  const el = props.element;
  const label =
    el?.props?.label ?? el?.label ?? (typeof el?.content === "string" ? el.content : undefined);
  return { modelValueKey: key, value: props.formValues?.[key], label };
}

function handleFormValueUpdate(child?: { modelValueKey: string; value: unknown; label?: string }) {
  emit("formValueUpdate", child ?? payload());
}

function handleOnBlur() {
  if (props.element.hasOwnProperty("triggerAction") && props.element.triggerAction == "blur") {
    emit("formValueUpdate", payload());
  }
  const p = payload();
  if (p) emit("fieldBlurred", p);
}
function handleValueUpdate(newValue: unknown) {
  const key = props.element?.modelValueKey;
  if (!key) {
    emit("formValueUpdate", undefined);
    return;
  }
  const el = props.element;
  const label =
    el?.props?.label ?? el?.label ?? (typeof el?.content === "string" ? el.content : undefined);
  emit("formValueUpdate", { modelValueKey: key, value: newValue, label });
}

function handleOnFocus() {
  const p = payload();
  if (p) emit("fieldFocused", p);
}
</script>
